// extracted by mini-css-extract-plugin
module.exports = {"textFaded":"Kate_textFaded__178lA","confirmDeleteForm":"Kate_confirmDeleteForm__3VFO5"};